import Vue from 'vue';
import { supabase } from '@/lib/supabase';
export default Vue.extend({
    name: 'UserMenu',
    data() {
        return {
            user: null,
            menuOpen: false,
        };
    },
    computed: {
        userName() {
            if (!this.user)
                return 'User';
            return this.user.user_metadata?.full_name ||
                this.user.user_metadata?.name ||
                this.user.email?.split('@')[0] ||
                'User';
        },
        userInitials() {
            if (!this.user)
                return 'U';
            const name = this.userName;
            const parts = name.split(' ');
            if (parts.length >= 2) {
                return (parts[0][0] + parts[1][0]).toUpperCase();
            }
            return name.substring(0, 2).toUpperCase();
        },
    },
    async mounted() {
        // Get current user
        const { data: { user } } = await supabase.auth.getUser();
        this.user = user;
        // Listen for auth changes
        supabase.auth.onAuthStateChange((_event, session) => {
            this.user = session?.user ?? null;
        });
    },
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        closeMenu() {
            this.menuOpen = false;
        },
        async handleSignOut() {
            try {
                await supabase.auth.signOut();
                this.$router.push('/login');
            }
            catch (error) {
                console.error('Error signing out:', error);
            }
        },
    },
});
